import { render } from "./JourneyCalendarPage.vue?vue&type=template&id=e9acab24"
import script from "./JourneyCalendarPage.vue?vue&type=script&lang=js"
export * from "./JourneyCalendarPage.vue?vue&type=script&lang=js"

import "./JourneyCalendarPage.vue?vue&type=style&index=0&id=e9acab24&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__